// ============ Navigation Constants ============
export const BUTTON_INDICES = { folder: -3, sheet: -2, doc: -1 };
export const INDEX_TO_BUTTON = { '-3': 'folder', '-2': 'sheet', '-1': 'doc' };

/**
 * Parse focus index string to structured object
 * @param {string|null} focusedIndex - Format: "depth_index"
 * @returns {{depth: number, index: number, isButton: boolean, buttonType: string|null}|null}
 */
export const parseFocusIndex = (focusedIndex) => {
    if (!focusedIndex) return null;
    const [depth, index] = focusedIndex.split('_').map(Number);
    const isButton = index < 0;
    return {
        depth,
        index,
        isButton,
        buttonType: isButton ? INDEX_TO_BUTTON[index] : null,
    };
};

/**
 * Create focus index string from depth and index
 * @param {number} depth
 * @param {number} index
 * @returns {string}
 */
export const createFocusIndex = (depth, index) => `${depth}_${index}`;

// ============ Folders State Selectors ============
export const selectFolders = (state) => state.folders;
export const selectFoldersData = (state) => state.folders.folders;
export const selectLinksData = (state) => state.folders.links;
export const selectShortcutsData = (state) => state.folders.shortcuts;
export const selectSelectedFolders = (state) => state.folders.selected_folders;
export const selectSortByStatus = (state) => state.folders.sortByStatus;
export const selectOpenFolder = (state) => state.folders.open_folder;

// ============ Global State Selectors ============
export const selectKeyboardNavigationActive = (state) => state.globalState.keyboardNavigationActive;

// ============ Auth State Selectors ============
export const selectUser = (state) => state.auth.user;
export const selectUserSettings = (state) => state.auth.user_settings;
export const selectIsMinimalView = (state) => state.auth.user_settings?.minimal_mode || false;

// ============ Derived Selectors ============

/**
 * Check if mobile portrait mode
 */
export const selectIsMobilePortrait = () => window?.innerWidth <= 600;

/**
 * Get all items at a specific depth in visual order (shortcuts → links → folders)
 * Note: This is for legacy Redux folders structure. New code should use Zustand store.
 */
export const selectAllItemsAtDepth = (state, depth) => {
    const folders = state.folders.folders[depth] || [];
    const links = state.folders.links[depth] || [];
    const shortcuts = state.folders.shortcuts[depth] || [];
    return [...shortcuts, ...links, ...folders];
};

/**
 * Check if we should fetch all folders (based on URL params)
 */
export const selectShouldFetchAllFolders = (state, folderId) => {
    if (!folderId) return false;
    const selectedFolders = state.folders.selected_folders;
    return !selectedFolders.includes(parseInt(folderId, 10));
};
